import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NxLinkComponent } from '@allianz/ng-aquila/link';
import { NgClass } from '@angular/common';
import { NxIconComponent } from '@allianz/ng-aquila/icon';
import { NxIndicatorComponent } from '@allianz/ng-aquila/indicator';

@Component({
  selector: 'ps20-frontend-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.css'],
  imports: [NxLinkComponent, NgClass, NxIconComponent, NxIndicatorComponent],
})
export class LinkComponent {
  @Input() icon = 'arrow-right';
  @Input() text = '';
  // eslint-disable-next-line  @angular-eslint/no-input-rename
  @Input('data-cy') dataCy = 'ps20-frontend-link';
  @Input() class = '';
  @Input() disabled = false;
  @Input() indicator = false;

  @Output() linkClick = new EventEmitter();

  indicatorAriaLabel = 'Neuigkeiten verfügbar';

  linkClicked(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    if (!this.disabled) {
      this.linkClick.emit();
    }
  }
}
